var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSwipeModeProspects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSwipeModeProspects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Swipe-view",
    transform: "translate(-375.000000, -265.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SwipeTittle",
    transform: "translate(313.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icSwipeModeProspects",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5513435,3.17088828 L14.4353965,3 L15.2342745,13.9368501 C15.2990484,14.7699305 14.6513095,15.5175667 13.8092489,15.5816499 L5,16.2224809 C5.19432167,16.7992289 5.71251278,17.2264496 6.36025167,17.2905327 L15.3854135,17.9954469 C16.2274741,18.05953 16.9831695,17.4400599 17.0479434,16.5856185 L17.9979604,4.81568801 C18.041143,3.96124659 17.3934041,3.23497139 16.5513435,3.17088828 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1678229,1.44632698 C13.1057307,0.594349487 12.4020194,-0.0610178153 11.5741237,0.00451891492 L1.3703093,0.790959677 C0.563110997,0.856496408 -0.0578107722,1.59924602 0.00428140469,2.47306909 L0.832177096,14.553673 C0.894269273,15.4056505 1.59798061,16.0610178 2.4258763,15.9954811 L3.25377199,15.9299444 C2.9640085,15.7988709 2.73633719,15.5148784 2.6949424,15.1435036 C2.6949424,15.121658 2.6949424,15.121658 2.6949424,15.121658 C2.50866587,11.975895 4.55770771,9.17966114 7.35185567,8.96120538 C10.1460036,8.76459519 12.5675985,11.1894542 12.7745724,14.3570628 C12.7745724,14.3789084 12.7745724,14.3789084 12.7745724,14.3789084 C12.7952698,14.7502832 12.6296907,15.0561213 12.3399272,15.2308859 L12.6296907,15.2090403 C13.436889,15.1435036 14.0578108,14.400754 13.9957186,13.5269309 L13.1678229,1.44632698 Z M7.20697392,8.30583807 C5.69606429,8.41506596 4.39212857,7.21355924 4.28864161,5.61883214 C4.18515465,4.02410503 5.32351122,2.6478337 6.83442086,2.53860582 C8.3453305,2.42937793 9.64926621,3.63088465 9.75275318,5.22561175 C9.83554274,6.82033886 8.71788356,8.19661019 7.20697392,8.30583807 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwipeModeProspects);
export default __webpack_public_path__ + "static/media/icSwipeModeProspects.fcab96bef1a306ab2f66616acbaf4a3a.svg";
export { ForwardRef as ReactComponent };